export const HOME_ROUTE_PATH = '/home';
export const OFFERS_ROUTE_PATH = '/offers';
export const UNLOCKED_OFFERS_ROUTE_PATH = '/unlocked-offers';
export const CUSTOMER_CARE_ROUTE_PATH = '/customer-care';
export const PROFILE_UPDATE_ROUTE_PATH = '/profile-update';
export const REWARDS_ROUTE_PATH = '/rewards';
export const TERMS_CONDITIONS_ROUTE_PATH = '/terms-conditions';
export const CONTACT_US_ROUTE_PATH = '/contact-us';
export const LOGIN_ROUTE_PATH = '/login';
export const SIGNUP_ROUTE_PATH = '/signup';
export const MISSING_SIZE_PATH = '/missingsizes';
export const SELECT_SIZE_PATH = '/selectsize';
export const SELECT_COLOR_PATH = '/selectcolor';
export const NOTIFY_PATH = '/notify';
export const CHECKOUT_PATH = '/checkout';
export const LANDING_PATH = '/qrcode';
export const IN_STORE_PROMOTIONS_PATH = '/in-store-promotions';
export const SHOPPINGBAG_PATH = '/shoppingbag';
export const RESET_PASSWORD = '/resetpassword';
export const LOCATION = '/location';
export const STORE_LOCATION = '/storelocation';
export const EMPLOYEE_SIGNIN = '/employeesignin';
export const TEMP_PASSWORD = '/temppassword';
export const TODAYS_ORDER_PATH = '/todaysorder';
export const PAYMENT_PATH = '/payment';
export const PROCESS_PAYMENT_PATH = '/process_payment';
export const MATCHPRICE_PATH = '/match-price';
export const CONFIRM_PATH = '/confirm';
export const THANKYOU = '/thankyou';
export const ELITE_PATH = '/elite';
export const SPLASH_PATH = '/splash';
export const FEEDBACK_PATH = '/feedback';
export const SCAN_PRODUCT = '/scan-product';
export const PAYMENT_ERROR = '/payment_error';
export const INVALID_ORDER_PATH = '/invalid-order';
